module.exports = __webpack_public_path__ + "static/media/Asset3.23abb287.png";